<template>
  <v-app>
    <v-main>
      <table-page :headers="headers" :items="items" :rowCount="25" />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
export default {
  components: {
    TablePage,
  },
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        { text: "Abbreviation", value: "abbreviation" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "creatorAccount" },
      ],
      items: [
        {
          title: "Shelf 1",
          abbreviation: "S1",
          description: "shelf 1 description",
        },
        {
          title: "Shelf 2",
          abbreviation: "S2",
          description: "shelf 2 description",
        },
        {
          title: "Shelf 3",
          abbreviation: "S3",
          description: "shelf 3 description",
        },
      ],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>